import React from 'react'
import { connect } from 'react-redux'
import Title from '../components/Title.jsx'
import Button from '../components/Button.jsx'
import NumberedList from '../components/NumberedList.jsx'

const HandKeyContainer = props => (
    <div className="handkey-container section-spacing">
        <Title title={props.langData.handKeyTitle} className="header1--center" />
        <div className="container">
            <div className="row">
                <div className="col-md-5 handkey-col">
                    <div className="handkey-list">
                        <NumberedList
                            text={props.langData.handKeyText}
                            itemArray={props.langData.handKeyItems}
                        />
                    </div>
                    <div className="handkey-button">
                        <div className="handkey-button__line"></div>
                        <div className="handkey-button__button">
                            <Button
                                link="/kontakt"
                                text={props.langData.handKeyButton}
                                type="arrow"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <img
            className="handkey-container__img hidden-sm hidden-xs"
            src="/images/el/bed_house.jpg"
        />
    </div>
)

HandKeyContainer.defaultProps = {
    itemData: []
}

const mapStateToProps = state => ({
    langData: state.langData.landing
})

export default connect(mapStateToProps)(HandKeyContainer)



// WEBPACK FOOTER //
// ./src/scripts/containers/HandKeyContainer.jsx